import script from "./StickyElement.vue?vue&type=script&setup=true&lang=js"
export * from "./StickyElement.vue?vue&type=script&setup=true&lang=js"

import "./StickyElement.vue?vue&type=style&index=0&id=1774bc6f&scoped=true&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1774bc6f"]])

export default __exports__